import { MobileOnlyOptions } from "./MobileOnlyOptions";
import type { LandingPageConfigOptions } from "landing/objects/LandingPageConfig";

export const LandingPageTemplate17: LandingPageConfigOptions = {
  consentAge: 18,
  ...MobileOnlyOptions,
};
